<style scoped>
    .plan-option.empty {
		width: 100%;
	}
	.label .placeholder {
		width: 100px;
	    background: #ddd;
	    height: 1.2em;
	}
    .dark .placeholder {
		background: #333;
	}
	.value .placeholder {
		width: 50px;
		background: #f6f6f6;
		 height: 1.2em;
	}
    .dark .value .placeholder {
		background: #333;
	}
	div.row:last-child .value .placeholder {
		width: 50px;
		background: #333;
	}
</style>

<template>
    <div class="rigid">
        <div v-if="loading" class="table rigid">
            <div class="row">
                <div class="gap label">
                    <div class="placeholder"></div>
                </div>
                <footer class="value rigid">
                    <div class="placeholder"></div>
                </footer>
            </div>
            <div class="row">
                <div class="gap label">
                    <div class="placeholder"></div>
                </div>
                <footer class="value rigid">
                    <div class="placeholder"></div>
                </footer>
            </div>
            <div class="row">
                <div class="gap label">
                    <div class="placeholder"></div>
                </div>
                <footer class="value rigid">
                    <div class="placeholder"></div>
                </footer>
            </div>
        </div>
        <div v-else-if="cost" class="table rigid">
            <div class="row">
                <div class="gap label">Subtotal</div>
                <footer class="rigid">
                    {{cost.subtotal}}
                </footer>
            </div>
            <div class="row">
                <div class="gap label">Estimated Tax</div>
                <footer class="rigid">
                    {{cost.tax}}
                </footer>
            </div>
            <div class="row">
                <div class="gap label">Total</div>
                <footer class="rigid">
                    {{cost.total}}
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
export default {
	name: 'EstimatedCost',
	props: {
		cost: Object,
		loading: Boolean
	}
};
</script>



// WEBPACK FOOTER //
// ./src/components/EstimatedCost.vue